export const PhaseTypes = Object.freeze({
  VAULTING:  'Vaulting',
  DEPOSIT:  'deposit',
  EXCHANGE: 'exchange',
  TRANSACT: 'transact'
});